import { MarketingAnalyticsChatInitEventType } from './marketingAnalyticsChatInitEventType';
import { MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';
import { MarketingAnalyticsLeadEventType } from './marketingAnalyticsLeadEventType';
import { MarketingAnalyticsPageViewEventType } from './marketingAnalyticsPageViewType';
import { MarketingAnalyticsResourceViewType } from './marketingAnalyticsResourceViewType';
import { MarketingAnalyticsScreenshotType } from './marketingAnalyticsScreenshotType';
import { MarketingAnalyticsUserActivityEventType } from './marketingAnalyticsUserActivityEventType';
import { MarketingAnalyticsUserInstallEventType } from './marketingAnalyticsUserInstallEventType';

export class MarketingAnalyticsEventTypeFactory {
    marketingAnalyticsHandlers: MarketingAnalyticsEventType[] = [
        new MarketingAnalyticsEventType(),
        new MarketingAnalyticsPageViewEventType(),
        new MarketingAnalyticsScreenshotType(),
        new MarketingAnalyticsResourceViewType(),
        new MarketingAnalyticsChatInitEventType(),
        new MarketingAnalyticsUserActivityEventType(),
        new MarketingAnalyticsUserInstallEventType(),
        new MarketingAnalyticsLeadEventType(),
    ];

    // @ts-expect-error * Automated Type Error Fix
    getEventTypeHandler(event): MarketingAnalyticsEventType {
        // @ts-expect-error * Automated Type Error Fix
        return this.marketingAnalyticsHandlers.find((handler) => handler.canHandle(event));
    }
}
